import { render } from "./SkillCircle.vue?vue&type=template&id=2c91f719"
import script from "./SkillCircle.vue?vue&type=script&lang=ts"
export * from "./SkillCircle.vue?vue&type=script&lang=ts"

import "./SkillCircle.vue?vue&type=style&index=0&id=2c91f719&lang=scss"
script.render = render

export default script